import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import ContentSkeleton from "../../Skeleton/ContentSkeleton";
import { getCalendarLists, getInitUrlCalendar, grantPermissionsCalendar, insertCalendar, postTokensOauth } from "../../../../api/calendar";
import { alertError } from "../../../../utils/logger";

/*
    Las fases de esta pagina son:
    1 -> refresh=true -> Pedimos la url de autenticación y la pegamos
    2 -> refresh=false&code... -> Se acaba de iniciar sesión en google y hay que setear los tokens. Una vez seteados salta directamente a la 3
    3 -> refresh=false -> Aquí ya accedemos al calendar. De momento se redirige a dashboard porque parece que no será necesario acceder al calendario desde aquí
*/
export default function CalendarPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const refr = searchParams.get("refresh")
    const code = searchParams.get("code")

    function state() {
        if (refr && refr === "true") return 1;
        if (refr && refr === "false" && code) return 2;
        return 3;
    }

    async function initCalendar() {
        if (state() !== 1) return;
        console.log("INIT");
        getInitUrlCalendar()
            .then((res) => {
                console.log(res?.data);
                window.location.replace(res.data);
            })
            .catch((error) => {
                alertError({ error, message: "No se ha podido cargar el calendario."})
            })
    }

    async function getToken() {
        if (state() !== 2) return;
        console.log("TOKEN");
        postTokensOauth(code, user?._id)
            .then((res) => {
                history.push("/dashboard");
            })
            .catch((error => {
                console.log(error?.request)
                history.push("/calendar?refresh=true");
            }))
    }

    async function getLists() {
        if (state() !== 3) return;
        console.log("LO INTENTO")
        getCalendarLists(user?._id)
            .then((res) => {
                console.log(res?.data?.items);
            })
            .catch((error => {
                console.log(error?.request)
                alertError({ error, message: "No se han podido cargar la lista de calendarios."})
            }))
    }

    async function insertInCalendar() {
        if (state() !== 3) return;
        console.log("LO INTENTO")
        insertCalendar(user?._id)
            .then((res) => {
                console.log(res?.data)
            })
            .catch((error => {
                console.log(error?.request)
                alertError({ error, message: "No se han podido cargar la lista de calendarios."})
            }))
    }

    async function grantPermissions() {
        if (state() !== 3) return;
        console.log("LO INTENTO")
        grantPermissionsCalendar(user?._id, user?.fullName, user?.surname, user?.email)
            .then((res) => {
                console.log(res?.data)
            })
            .catch((error => {
                console.log(error?.request)
                alertError({ error, message: "No se han podido cargar la lista de calendarios."})
            }))
    }

    useEffect(() => {
        initCalendar();
        getToken();
        if (state() === 3) history.push("/dashboard");
    }, [])

    if (state() !== 3) return (<> <ContentSkeleton /> </>);
    return (<>
    
        <button
            type="button"
            className="btn btn-primary text-white"
            onClick={() => getLists()}
        >
            Coger listas
        </button>
    
        <button
            type="button"
            className="btn btn-primary text-white"
            onClick={() => insertInCalendar()}
        >
            Insertar calendario
        </button>
    
        <button
            type="button"
            className="btn btn-primary text-white"
            onClick={() => grantPermissions()}
        >
            Permisos!
        </button>
    </>)
}